import { Grid, Space } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News, Banner, Contact } from "../components/Project";
import { HashLink } from "react-router-hash-link";
import { Scroll } from "../components/Animation";

const Service = () => {
  return (
    <>
      <Head slug="page-service"></Head>

      <div className="l-row">
        <div className="p-box__wrap--about">
          <Space size={["160px", "64px"]} />
          <Space size={["0px 0 64px", "0px 0 40px"]}>
            <Texts
              slug="about/title"
              addText="運送のことなら、<br>株式会社カナメカーゴへお任せ下さい。"
            ></Texts>
          </Space>
          <Texts
            slug="about/body"
            addText="兵庫県神戸市を拠点に、運送に関する様々な業務を行っております。<br>創業以来、ひとつひとつの仕事を丁寧にこなし、信頼と安心の配送で高い評価を得るため、日々向上心を持ってお仕事をさせていただいております。<br><br>各社様から配送のご依頼をいただき、全国にお荷物を運んでおります。何か気になることやお困りごとがございましたら、お気軽にご相談ください。"
          ></Texts>
          <Space size={["160px", "80px"]} />
        </div>
      </div>

      <Point />
      <Space size={['120px 0', '120px 0']}>
        <CanList />
      </Space>

      <Contact />

      <News />

      <Banner />
    </>
  );
};

const CanList = () => {
  const args = {
    slug: "company",
    length: 4,
    addText: [
      [
        "小規模、中規模の保管・配送承ります。<br>自転車・トイレットペーパー・水・包材など",
        "お店を経営していると、商品の保管場所に困ったりしていませんか？<br>保管場所だけに倉庫を借りるのは…。というお客様にお喜びいただいております。<br>1 パレットの少量でのご利用も大歓迎です。",
      ],
      [
        "自社ドライバーさん、<br>まだ遠方まで配送していませんか？",
        "運送ドライバーさんを自社で雇われている企業様も多いかと思います。<br>例えば、京都の会社様が姫路まで単独便で配送をしていると、人件費や所要時間を考えると割に合わないかと思います。<br>当社に配送を依頼することにより、人件費や時間を有効的に使うことができます。",
      ],
      [
        "梱包・軽作業・各種配送業務承ります。",
        "個人様、法人様、教育機関など、多岐にわたる業種の企業様からご利用頂いおております。<br>封入作業やセットアップ、発送代行など少ない量から大きな量まで承ります。お気軽にご相談ください。",
      ],
      [
        "レンタカー事業",
        "",
      ],
    ],
  };
  const Item = (props) => {
    return (
      <>
        <li className="items c-grid__items--com" data-state={props.index % 2 ? 'right' : 'left'}>
          <div className="l-row">
            <div className="c-grid__items--com__inner">
              <Media class="p-img__number" src={`point/num${props.index}`} alt="number"></Media>
              <Texts
                class="c-text--main"
                slug={`feature/title${props.index}`}
                addText={args.addText[props.index][0]}
              ></Texts>
              <div className="pc"></div>
              {props.index == 3 ?
                <>
                </>
                :
                <Texts
                  slug={`feature/body${props.index}`}
                  addText={args.addText[props.index][1]}
                ></Texts>
              }
            </div>
          </div>
          {props.index == 3 ?
            <></>
            :
            <div className="l-row" data-state={props.index % 2 ? 'right' : 'left'}>
              <Scroll>
                <Media class="p-img__company" state={props.index % 2 ? 'right' : 'left'} alt="media" src={`company/list${props.index}`}></Media>
              </Scroll>
            </div>
          }
        </li>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <Title slug="feature" enClass="c-text--center" jpClass="c-text--center"></Title>
      <Space size={['80px 0 0', '80px 0 0']}>
        <Space size={['0 0 48px', '0 0 32px']}>
          {/* <Texts slug="feature/body" class="c-text--center"></Texts> */}
          <ul className="list c-grid__list--com" data-state="service">
            {items}
          </ul>
        </Space>
      </Space>
    </>
  );
};

const Point = () => {
  return (
    <>
      <div className="p-box__wrap--white">
        <Space size={['120px', '80px']}></Space>
        <div className="l-row">
          <div className="c-grid--center">
            <Title slug="point"></Title>
          </div>
        </div>
        <Space size={["80px 0 0", "80px 0 0"]}>
          <PointList />
        </Space>
        <Space size={['120px', '80px']}></Space>
      </div>
    </>
  )
}
const PointList = () => {
  const args = {
    slug: "point",
    length: 3,
    addText: [
      [
        "共同配送",
        "「共同配送」とは、届け先が一緒な複数の荷主様の荷物をひとまとめにして、1台のトラックに相乗りさせる仕組みのことです。共同配送では、同じカテゴリーの商品を配送先別に積み合わせることで、効率的な配送が可能となりコストダウンを実現することができます。<br><br>建築資材、紙類、冷凍・冷凍食品、菓子、お酒などの共同配送はお任せ下さい。<br>当社では、兵庫・大阪・京都に倉庫を構えており、お客様の様々な配送ニーズへお応えできます。",
        [
          [
            "コストダウン",
            "同一カテゴリの商品を配送先様ごとに積み合わせて一括配送することにより、配送効率化とローコスト化を実現できます。",
          ],
          [
            "顧客の負担を軽減",
            "配送先様も荷受け作業の効率化を図ることができるため、負担を減らすことが可能です。",
          ],
          [
            "環境に優しい",
            "共同配送の導入により、トラック台数を削減することで、排出されるCO₂が大幅に減少し、地球にやさしい取り組みとなります。",
          ],
        ],
      ],
      [
        "緊急便",
        "「困ったな」という多くの場合は、急ぎの荷物がありながらもトラックの手配がつかないなど、文字通り緊急な状況です。そんな突然発生するお客様の「困った」には、株式会社カナメカーゴにお任せください。<br>私たちは、ご希望を叶えるために最大限の対応をいたします。<br>安全で丁寧、かつ正確な配送を行い、焦りや不安を解消できるよう心掛けています。",
      ],
      [
        "定期便",
        "オフィスや工場、店舗間の輸送や企業様からお得意様への配送・納品などの請け負いを承っております。<br>お客様のご要望や目的に合わせて、細やかな対応を心掛けています。お見積もりなど、お気軽にご相談ください。",
      ],
    ],
  };
  const SquItem = (props) => {
    return (
      <>
        <div>
          <Texts
            slug={`service/squ-in-title`}
            addText={args.addText[0][2][props.index][0]}
          ></Texts>
          <Space size={["16px 0 0", "16px 0 0"]}>
            <Texts
              slug={`service/squ-in-body`}
              addText={args.addText[0][2][props.index][1]}
            ></Texts>
          </Space>
        </div>
      </>
    );
  };
  const Item = (props) => {
    return (
      <>
        <li className="items c-grid__items--point" data-state="service">
          <div className="c-grid__items--point__left" data-state="service">
            <Media
              src={`point/num${props.index}`}
              class="p-img__number"
              alt="number"
            ></Media>
          </div>
          <div>
            <Texts
              class="c-text--main"
              slug={`point/title`}
              addText={args.addText[props.index][0]}
            ></Texts>
            <Space
              size={
                props.index == 0
                  ? ["48px 0 40px", "24px 0"]
                  : ["24px 0 0", "24px 0 0"]
              }
            >
              <Texts
                slug={`point/body`}
                addText={args.addText[props.index][1]}
              ></Texts>
            </Space>
            {props.index == 0 && (
              <div className="">
                <Media
                  src={`point/list${props.index}`}
                  sp="sp"
                  alt="list"
                ></Media>
                <Space size={["40px 0 0", "24px 0 0"]}>
                  <div className="p-box__wrap--point__square">
                    <Texts
                      slug="service/squ-title"
                      class="c-text--main"
                    ></Texts>
                    <Space size={["24px 0 0", "24px 0 0"]}>
                      <div className="p-box__wrap--point__square--inner">
                        <SquItem index="0" />
                        <SquItem index="1" />
                        <SquItem index="2" />
                      </div>
                    </Space>
                  </div>
                </Space>
              </div>
            )}
          </div>
        </li>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < args.length; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }

  return (
    <>
      <div className="l-row">
        <ul className="list c-grid__list--point" data-state="service">
          {items}
        </ul>
      </div>
    </>
  );
};

export default Service;